import { useEffect, useState } from 'react';
import { Menu as MenuIcon, ShoppingBag, X } from 'lucide-react';
import { useScrollTo } from '../hooks/use-scroll-to';
import { CONTACT } from '../data/site';

const NAV = [
  { id: 'mais-vendidos', label: 'Mais vendidos', testid: 'navbar-link-mais-vendidos' },
  { id: 'cardapio', label: 'Cardápio', testid: 'navbar-link-cardapio' },
  { id: 'como-chegar', label: 'Como chegar', testid: 'navbar-link-como-chegar' },
  { id: 'redes-sociais', label: 'Redes sociais', testid: 'navbar-link-redes-sociais' },
  { id: 'sobre', label: 'Sobre nós', testid: 'navbar-link-sobre-nos' },
  { id: 'contato', label: 'Contato', testid: 'navbar-link-contato' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const scrollTo = useScrollTo();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollTo(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled || open
          ? 'border-white/10 bg-[#0D0D0F]/85 backdrop-blur-xl'
          : 'border-transparent bg-transparent'
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => scrollTo(null)}
          className="flex items-center gap-2"
          data-testid="navbar-brand-logo"
          aria-label="Riths Burger — voltar ao topo"
        >
          <img
            src="/logo.png"
            alt="Rith's Burger"
            className="h-20 w-auto translate-y-2 drop-shadow-[0_10px_20px_rgba(0,0,0,0.65)] sm:h-24 sm:translate-y-3"
          />
        </button>

        <nav className="hidden items-center gap-7 lg:flex">
          {NAV.map((item) => (
            <button
              key={item.id}
              onClick={() => go(item.id)}
              data-testid={item.testid}
              className="text-sm font-medium text-zinc-300 transition-colors hover:text-[#FF5500]"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CONTACT.ifood}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-ifood-cta-button"
            className="hidden items-center gap-2 rounded-full bg-[#EA1D2C] px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_24px_rgba(234,29,44,0.45)] sm:inline-flex"
          >
            <ShoppingBag size={16} /> Pedir online
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-white lg:hidden"
            data-testid="navbar-mobile-toggle"
            aria-label="Abrir menu"
          >
            {open ? <X size={20} /> : <MenuIcon size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="border-t border-white/10 bg-[#0D0D0F]/95 backdrop-blur-xl lg:hidden"
          data-testid="navbar-mobile-menu"
        >
          <div className="space-y-1 px-4 py-4">
            {NAV.map((item) => (
              <button
                key={item.id}
                onClick={() => go(item.id)}
                data-testid={`${item.testid}-mobile`}
                className="block w-full rounded-lg px-3 py-3 text-left text-base font-medium text-zinc-200 hover:bg-white/5"
              >
                {item.label}
              </button>
            ))}
            <a
              href={CONTACT.ifood}
              target="_blank"
              rel="noreferrer"
              className="mt-2 flex items-center justify-center gap-2 rounded-full bg-[#EA1D2C] px-5 py-3 text-sm font-bold text-white"
              data-testid="navbar-ifood-cta-button-mobile"
            >
              <ShoppingBag size={16} /> Pedir online
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
